<template>
  <div class="w-full px-7 py-6 white-rounded-box mb-7 h-28">

    <div
      class="flex items-center xl:mb-2 mb-0"
    >
      <!-- TODO use users details -->
      <!-- <svg-vue
        icon="avatar"
        class="w-6 h-6 inline-block mr-4 default-avatar-icon"
      /> -->
      <img
        v-show="!showingDefaultAvatar"
        @load="showingDefaultAvatar = false"
        :src="user.avatar_uri"
        class="w-8 h-8 z-0 rounded-full outline:none hover:cursor-default "
        :class="user.type=='pro'? (user.care_score>3? (user.care_score>=4? 'badgeBlue' : 'badgeGreen') : '' ): ''"
      />
      <svg-vue
        v-show="showingDefaultAvatar"
        icon="circle-user"
        title="default user avatar"
        class="h-6 mr-2 hover:cursor-pointer"
        :class="user.type=='pro'? (user.care_score>3? (user.care_score>=4? 'fill-salesium-blue' : 'fill-salesium-green') : '' ): ''"
      />
      <h2 class="xl:text-2xl lg:text-lg text-base font-bold">
        {{ displayName }}
      </h2>
    </div>
    <div class="ml-1 xl:ml-10">
      <div class="lg:text-lg md:text-md text-hint flex items-center">
        <!-- TODO: make status dynamic and save to backend on change -->

        <t-dropdown :variant="availabilityVariant">
          <div class="py-1 rounded-md shadow-xs">
            <a
              @click.prevent="onChangeAvailability('availabilityGreen')"
              class="block px-4 py-2 text-sm leading-5 text-gray-700 transition duration-150 ease-in-out hover:bg-gray-100 focus:outline-none focus:bg-gray-100"
              role="menuitem"
              v-if="!loading"
            >
            <span
                  class="w-2.5 h-2.5 md:w-3 md:h-3 lg:w-3.5 lg:h-3.5 rounded-full inline-block mr-1"
                  :class="{'bg-salesium-green': true, 'bg-salesium-red': false, 'bg-salesium-bronze': false}"
                ></span>
              Available
            </a>
            <a
              @click.prevent="onChangeAvailability('availabilityBronze')"
              class="block px-4 py-2 text-sm leading-5 text-gray-700 transition duration-150 ease-in-out hover:bg-gray-100 focus:outline-none focus:bg-gray-100"
              role="menuitem"
              v-if="!loading"
            >
            <span
                  class="w-2.5 h-2.5 md:w-3 md:h-3 lg:w-3.5 lg:h-3.5 rounded-full inline-block mr-1"
                  :class="{'bg-salesium-green': false, 'bg-salesium-red': false, 'bg-salesium-bronze': true}"
                ></span>
              Busy
            </a>
            <a
              @click.prevent="onChangeAvailability('availabilityRed')"
              class="block px-4 py-2 text-sm leading-5 text-gray-700 transition duration-150 ease-in-out hover:bg-gray-100 focus:outline-none focus:bg-gray-100"
              role="menuitem"
              v-if="!loading"
            >
            <span
                  class="w-2.5 h-2.5 md:w-3 md:h-3 lg:w-3.5 lg:h-3.5 rounded-full inline-block mr-1"
                  :class="{'bg-salesium-green': false, 'bg-salesium-red': true, 'bg-salesium-bronze': false}"
                ></span>
              Not Available
            </a>
            <div v-if="loading"
              style="border-top-color:transparent"
              class="w-8 h-8 border-4 mx-auto my-5 border-blue-400 border-solid rounded-full animate-spin"
            ></div>
          </div>
        </t-dropdown>

        <span class="py-2">@{{ user.username }}</span>

      </div>
    </div>
  </div>
</template>
<script>
import OrgList from "./OrgList";
export default {
    props: ['user'],
    data() {
        return {
            displayName: this.user.display_name,
            loading: false,
            availabilityVariant: 'availabilityGreen',
            showingDefaultAvatar: true
        };
    },
    methods: {
        async onChangeAvailability(availabilityVariant){
          this.loading = true;
          setTimeout(() => {
                    this.loading = false;
                    this.$toasted.global.toast_success('Availability updated');
                    this.availabilityVariant = availabilityVariant;
                }, 2000);
        },
    },
    components: {
        OrgList,
    },
};
</script>

<style scoped>
.badgeBlue{
  border-width: 4px;
}
.badgeGreen{
  border-width: 4px;
}
</style>
